@if (isOpen) {
  <!-- Panel -->
  <div #panel class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[520px] max-h-[70vh] bg-white dark:bg-dark-card rounded-lg shadow-xl border border-gray-200 dark:border-dark-border flex flex-col animate-fadein">

    <!-- Header -->
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-dark-border">
      <span class="font-semibold text-primary dark:text-dark-text text-base">{{ 'hotkeys.title' | translate }}</span>
      <kbd class="text-[11px] font-mono text-slate-400 dark:text-dark-muted bg-slate-100 dark:bg-dark-hover border border-slate-200 dark:border-dark-border rounded px-1.5 py-0.5 leading-none">F1</kbd>
    </div>

    <!-- Groups -->
    <div class="overflow-y-auto flex-1 px-5 py-3 flex flex-col gap-5">
      @for (group of groups(); track group.group) {
        <div>
          <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400 dark:text-dark-muted mb-2">
            {{ group.group | translate }}
          </p>
          <div class="flex flex-col gap-0.5">
            @for (binding of group.bindings; track binding.id) {
              <div class="flex items-center justify-between py-2 px-3 rounded hover:bg-gray-50 dark:hover:bg-dark-hover">
                <span class="text-sm text-slate-600 dark:text-dark-text">{{ binding.label! | translate }}</span>
                <kbd class="shrink-0 text-[11px] font-mono text-slate-500 dark:text-dark-muted bg-slate-100 dark:bg-dark-hover border border-slate-200 dark:border-dark-border rounded px-1.5 py-0.5 leading-none">
                  {{ hotkeyService.formatLabel(binding.keys, binding.doubleTap) }}
                </kbd>
              </div>
            }
          </div>
        </div>
      }

      @if (groups().length === 0) {
        <p class="text-sm text-slate-400 dark:text-dark-muted text-center py-6">{{ 'hotkeys.empty' | translate }}</p>
      }
    </div>

    <!-- Footer -->
    <div class="px-5 py-3 border-t border-gray-100 dark:border-dark-border flex items-center gap-4 text-[11px] text-slate-400 dark:text-dark-muted">
      <span><kbd class="font-mono bg-slate-100 dark:bg-dark-hover border border-slate-200 dark:border-dark-border rounded px-1 leading-none">Esc</kbd> {{ 'hotkeys.footer.close' | translate }}</span>
    </div>
  </div>
}
